import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'module-upgrade',
    templateUrl: './module-upgrade.component.html',
    styleUrls: ['./module-upgrade.component.scss'],
})
export class ModuleUpgradeComponent implements OnInit {
    dashboardGrid: string;
    dashboardGridContainer: string;

    @Input() headline: string;
    @Input() shortOverview: string;
    @Input() selligPointHeader: string;
    @Input() logoPlaceholder: string;
    @Input() moduleShortDescription: string;
    @Input() backgroundColor: string;
    @Input() showCompensafelink?: boolean = false;

    constructor() {}

    ngOnInit() {
        var divToChange = document.getElementById('leftCard');
        divToChange.style.backgroundColor = this.backgroundColor;
    }
}
